export default "__VITE_ASSET__NHIVBFzN__"